export default () => window.innerWidth <= 768;
